import { render, staticRenderFns } from "./PaymentDashboard.vue?vue&type=template&id=58479ad6&"
import script from "./PaymentDashboard.vue?vue&type=script&lang=js&"
export * from "./PaymentDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports